import * as ActionTypes from "../ActionTypes";

const initialState = {
    isLoading: false,
    candidateSourceData: [],
};

export const CandidateSourceReducer = function (state = initialState, action) {
    switch (action.type) {
        case ActionTypes.CANDIDATE_SOURCE_GET_REQUEST:
            return {
                ...state,
                isLoading: true,
                candidateSourceData: []
            };
        case ActionTypes.CANDIDATE_SOURCE_GET_SUCCESS:
        case ActionTypes.CANDIDATE_SOURCE_UPSERT_SUCCESS:
        case ActionTypes.CANDIDATE_SOURCE_DELETE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                candidateSourceData: action.payload?.data?.data
            };
        case ActionTypes.CANDIDATE_SOURCE_UPSERT_REQUEST:
        case ActionTypes.CANDIDATE_SOURCE_DELETE_REQUEST:
            return {
                ...state,
                isLoading: true,
            };
        case ActionTypes.CANDIDATE_SOURCE_GET_ERROR:
        case ActionTypes.CANDIDATE_SOURCE_UPSERT_ERROR:
        case ActionTypes.CANDIDATE_SOURCE_DELETE_ERROR:
            return {
                ...state,
                isLoading: false
            };
        default:
            return state;
    }
};
